import { Routes } from '@angular/router';

export const routes: Routes = [];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/user/user.routes.ts